const MODEL_ICON_MAP: { pattern: string; icon: string }[] = [
  { pattern: "gpt", icon: "/openai_logo.png" },
  { pattern: "comma", icon: "/alan_icon_fav.png" },
  { pattern: "mistral", icon: "/mistral-logo.png" },
  { pattern: "claude", icon: "/claude_logo.png" },
];

export default MODEL_ICON_MAP;
